module.exports = __webpack_public_path__ + "static/media/fortnite_subreddit.36f136b0.png";